<template>
  <div v-if="code">
    <v-card
      class="ma-4"
      elevation="4"
    >
      <v-card-title>
        <v-avatar 
          v-if="user.photoURL"
          size="36"
        >
          <img :src="user.photoURL" :alt="user.name">
        </v-avatar>

        <span class="ma-2" v-if="challenge">
          <router-link :to="`/challenge/${challenge.name}`">{{ challenge.name }}</router-link>
        </span>
        <span class="ma-2" v-else>
          {{ code.challengeName ? code.challengeName : "非公開にされたチャレンジ" }}
        </span>
        への提出コード

        <v-spacer />

        <v-btn
          v-if="$store.state.user.uid == code.user"
          class="mr-6"
          color="error"
          :disabled="code.testing"
          @click.stop="delete_dialog = true"
        >
          削除
        </v-btn>

        <v-dialog
          v-model="delete_dialog"
          max-width="290"
        >
          <v-card>
            <v-card-title>
              コードを削除しますか？
            </v-card-title>
    
            <v-card-actions>
              <v-btn
                @click="delete_dialog = false"
              >
                キャンセル
              </v-btn>

              <v-spacer />
    
              <v-btn
                color="error"
                @click="delete_dialog = false; delete_code()"
              >
                削除
              </v-btn>
            </v-card-actions>
          </v-card> 
        </v-dialog>

        <v-btn
          icon
          :color="likeColor"
          :disabled="!$store.state.user.authenticated"
          @click="toggleLike"
        >
          <v-icon>mdi-thumb-up</v-icon>
        </v-btn>
        <span class="ml-1 mr-4">
          {{ likeCount }}
        </span>
      </v-card-title>

      <v-card-subtitle>
        提出時刻 : {{ submittedAt }}
      </v-card-subtitle>

      <div class="ma-4">
        <ResultCard v-if="code" :code="code" />
      </div>

      <v-tabs>
        <v-tab to="#top" v-if="kernel_source">コード</v-tab>
        <v-tab to="#csim_log" v-if="csim_log">CSimログ</v-tab>
        <v-tab to="#hls_log" v-if="hls_log">HLSログ</v-tab>
        <v-tab to="#cosim_log" v-if="cosim_log">CoSimログ</v-tab>

        <v-tab-item value="top">
          <v-divider></v-divider>
          <HighlightedCode :code-text="kernel_source" />
        </v-tab-item>

        <v-tab-item value="csim_log">
          <v-divider></v-divider>
          <HighlightedCode
            :code-text="csim_log"
          />
        </v-tab-item>

        <v-tab-item value="hls_log">
          <v-divider></v-divider>
          <HighlightedCode
            :code-text="hls_log"
          />
        </v-tab-item>

        <v-tab-item value="cosim_log">
          <v-divider></v-divider>
          <HighlightedCode
            :code-text="cosim_log"
          />
        </v-tab-item>

      </v-tabs>
    </v-card>
  </div>
</template>

<script>
import pako from 'pako'
import firebase from "@/firebase/firebase.js"
import {db} from "@/firebase/db.js"
import ResultCard from '@/components/ResultCard.vue'
import HighlightedCode from '@/components/HighlightedCode.vue'

export default {
  components: {
    ResultCard,
    HighlightedCode,
  },
  data: () => ({
    codeRef: null,
    code: null,
    files: null,
    user: null,
    challenge: null,
    delete_dialog: false,
  }),
  computed: {
    kernel_source: function () {
      return this.files && this.files.kernel_source ?
        new TextDecoder().decode(pako.inflate(this.files.kernel_source.toUint8Array())) : ""
    },
    csim_log: function () {
      return this.files && this.files.csim_log ?
        new TextDecoder().decode(pako.inflate(this.files.csim_log.toUint8Array())) : null
    },
    hls_log: function () {
      return this.files && this.files.hls_log ?
        new TextDecoder().decode(pako.inflate(this.files.hls_log.toUint8Array())) : null
    },
    cosim_log: function () {
      return this.files && this.files.cosim_log ?
        new TextDecoder().decode(pako.inflate(this.files.cosim_log.toUint8Array())) : null
    },
    submittedAt: function () {
      return this.code ? this.code.submittedAt.toDate().toLocaleString('ja-JP') : ""
    },
    likeCount: function () {
      return this.code && this.code.likes ? this.code.likes.length : 0
    },
    likeColor: function () {
      const likes = this.code.likes
      return this.$store.state.user.authenticated && likes && likes.includes(this.$store.state.user.uid) ?
        "primary" : "grey"
    },
  },
  methods: {
    async delete_code() {
      this.$unbind('files')
      await db.doc(this.code.files).delete()
      try {
        this.$unbind('challenge')
        const uid = this.$store.state.user.uid
        // TODO submitUsers.includes(uid) == db.collection("user").doc(uid).collection("codes").where("challengePath", "==", this.code.challengePath).count() > 1
        await db.doc(this.code.challengePath).update({
          submitUsers: firebase.firestore.FieldValue.arrayRemove(uid),
          submitCount : firebase.firestore.FieldValue.increment(-1),
        })
      } catch (e) {
        // This update may fail
      }
      this.$unbind('code')
      await this.codeRef.delete()
      this.$router.replace("/my-codes")
    },
    async toggleLike() {
      if (this.$store.state.user.authenticated) {
        const uid = this.$store.state.user.uid
        if (this.code.likes === undefined || !this.code.likes.includes(uid)) {
          this.codeRef.update({
            likes: firebase.firestore.FieldValue.arrayUnion(uid),
            likeCount: firebase.firestore.FieldValue.increment(1),
          })
        } else {
          this.codeRef.update({
            likes: firebase.firestore.FieldValue.arrayRemove(uid),
            likeCount: firebase.firestore.FieldValue.increment(-1),
          })
        }
      }
    },
  },
  async created() {
    const unameDoc = await db.collection("usernames").doc(this.$route.params.user_name).get()
    if (unameDoc.exists) {
      this.userRef = db.collection("users").doc(unameDoc.data().user)
      this.codeRef = this.userRef.collection("codes").doc(this.$route.params.code_id)

      this.$bind("user", this.userRef)
      this.$bind("code", this.codeRef)

      const codeDoc = await this.codeRef.get()
      if (codeDoc.exists) {
        this.$bind("challenge", db.doc(codeDoc.data().challengePath))
        this.$bind("files", db.doc(codeDoc.data().files))
      }
    }
  },
}
</script>




